export type SubscriptionStatusType =
  | "active"
  | "alert"
  | "cancelled"
  | "completed"
  | "paused"
  | "pendactivation"
  | "pendcancel";

export type SubscriptionType = {
  name: string;
  status: SubscriptionStatusType;
};

export type MembershipRoleType = "member" | "non-member" | "ex-member";

type StaffRoleType = "admin" | "coach" | "frontdesk";

export type LeadStatusType =
  | "attempted"
  | "contacted"
  | "converted"
  | "disqualified"
  | "in discussion"
  | "new lead";

type PeopleRecordType = {
  email: string;
  firstName: string;
  imageUrl?: string | null;
  lastCheckin?: string | null;
  lastName: string;
  userId: number;
  userUuid: string;
};

export type MemberRecordType = PeopleRecordType & {
  churnDate?: string | null;
  membershipRole: MembershipRoleType;
  subscriptions: SubscriptionType[];
};

export type LeadRecordType = PeopleRecordType & {
  firstContacted: string;
  leadStatus: LeadStatusType;
  subscriptions: Pick<SubscriptionType, "name">[];
};

export type StaffRecordType = PeopleRecordType & {
  membershipRole: StaffRoleType;
};

export const PEOPLE_TYPE = {
  MEMBERS: "members",
  LEADS: "leads",
  STAFF: "staff",
} as const;

export type PeopleType = (typeof PEOPLE_TYPE)[keyof typeof PEOPLE_TYPE];

export type ExportPeopleFilterType = {
  membershipRole?: MembershipRoleType[] | StaffRoleType[];
  status?: SubscriptionStatusType[];
  leadStatus?: LeadStatusType[];
};

export type TableRowActionType = {
  title: string;
  url: string;
  nasUuidInUrl: boolean;
};

export const MESSAGE_TYPES = {
  EMAIL: "email",
  SMS: "sms",
} as const;

export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

export type SendMessageFormValuesType = {
  messageType: (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];
  replyTo: string;
  bccMe: boolean;
  bccCoaches: boolean;
  bccAdmins: boolean;
  subject: string;
  emailText: string;
  smsMessage: string;
};

export type SendMessageType = {
  messageType: (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];
  sms?: {
    to: string[];
    message: string;
  };
  email?: {
    to: string[];
    replyTo?: string;
    bccMe: boolean;
    bccCoaches: boolean;
    bccAdmins: boolean;
    subject: string;
    text: string;
  };
};
